<template>
    <v-card
        class="mb-3"
    >
        <v-stepper
            v-model="current_step"
            alt-labels
        >
            <v-stepper-header>
                <template v-for="n in steps">
                    <v-stepper-step
                        :key="`${n.id}-step`"
                        :complete="current_step > n.id"
                        :step="n.id"
                        :complete-icon="editable_steps ? '$edit' : '$complete'"
                        class="stepper-label-center"
                        :color="$vuetify.theme.dark ? 'accent' : 'primary'"
                        @click.stop.prevent.capture="checkFormValidation(n.id)"
                    >
                        <span
                            class="text-uppercase"
                            :class="$vuetify.theme.dark ? 'dark-label' : ''"
                        >
                            {{ n.label }}
                        </span>
                    </v-stepper-step>

                    <v-divider
                        v-if="n.id !== steps.length"
                        :key="n.id"
                    ></v-divider>
                </template>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content
                    v-for="n in steps"
                    :key="`${n.id}-step-content`"
                    :step="n.id"
                    class="pa-2"
                >
                    <key-plan-step-one
                        ref="step"
                        v-if="current_step === 1"
                        :title="n.label"
                    ></key-plan-step-one>
                    <key-plan-step-two
                        ref="step"
                        v-if="current_step === 2"
                        :title="n.label"
                    ></key-plan-step-two>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-card>
</template>

<script>
    import KeyPlanMixin from "./keyplan";

    import KeyPlanStepOne from "./Steps/1";
    import KeyPlanStepTwo from "./Steps/2";

    export default {
        name: "KeyPlanStepper",

        mixins: [
            KeyPlanMixin
        ],

        components: {
            KeyPlanStepOne,
            KeyPlanStepTwo
        },

        data() {
            return {
                steps: [
                    {
                        'id': 1,
                        'label': 'Plan information'
                    },
                    {
                        'id': 2,
                        'label': 'Employee verification'
                    }
                ],
            }
        },

        methods: {
            checkFormValidation(step) {
                if (this.editable_steps) {
                    this.$refs.step.$refs.form.validateForm()
                        .then((response) => {
                            if (!this.formIsValid) {
                                return;
                            }

                            this.current_step = step;
                        });
                }
            }
        }
    }
</script>
